<template>
  <article
    class="pubblication-listing-block"
    ref="block"
    :class="{
      'is-hover': isHover,
      'is-alternative': alternative,
    }"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <div class="pubblication-listing-block__wrap">
      <div
        v-if="props.item?.image"
        class="pubblication-listing-block__image__wrap"
        data-animate="block-image-preview"
      >
        <WidgetPicture
          class="pubblication-listing-block__image"
          :image="{ custom: props.item?.image?.responsiveImage }"
          :lazyLoad="true"
          :alt="props.item.title"
        />
      </div>

      <div class="pubblication-listing-block__content__wrap">
        <div class="pubblication-listing-block__content">
          <h2 class="text-l-1">
            {{ props.item.title }}
          </h2>
          <div class="pubblication-listing-block__content-details">
            <p class="is-text-uppercase text-s-1">
              <span class="--grey">Authors</span> {{ props.item.author }}
            </p>
            <p class="is-text-uppercase text-s-1">
              <span class="--grey">Journal</span>
              {{ props.item.newsOutlets }}
            </p>
            <p class="is-text-uppercase text-s-1">
              <span class="--grey">Year</span> {{ props.item.year }}
            </p>
          </div>

          <template v-if="props.item.pdf && props.item.pdf.url">
            <a
              :href="props.item.pdf.url"
              target="_blank"
              class="button-download pubblication-listing-block__content-download"
            >
              <span class="text-m-1 is-text-uppercase">Download Pdf</span>
              <img
                src="@/assets/img/ico/download.svg"
                width="26"
                height="26"
                alt="Download"
            /></a>
          </template>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'PagesPubblicationListingBlock',
}
</script>

<script setup>
import { gsap } from 'gsap'

const props = defineProps({
  item: Object,
  alternative: Boolean,
})

const block = ref(null)

const isHover = ref(false)
const touch = ref(false)

const duration = 0.6
const durationFast = 0.4
const ease = 'power2.inOut'

onMounted(() => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints /// !! trasformano 0/1 in Bool
})

const onMouseEnter = () => {
  if (touch.value) return false

  const parent = block.value
  const video = parent?.querySelector('[data-animate="block-video-preview"]')
  const button = parent?.querySelectorAll('[data-animate="block-quick-view"]')
  const tags = parent?.querySelectorAll('[data-animate="block-tag"]')

  isHover.value = true

  /*if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 1, duration, ease })
  }

  if (hasQuickView.value || props.alternative) {
    gsap.to(button, { y: '0%', duration: durationFast, ease, stagger: 0.1 })
  }
  if (tags?.length) {
    gsap.to(tags, { y: '0%', duration: durationFast, ease, stagger: 0.1 })
  }*/
}

const onMouseLeave = () => {
  if (touch.value) return false

  const parent = block.value
  const video = parent?.querySelector('[data-animate="block-video-preview"]')
  const button = parent?.querySelectorAll('[data-animate="block-quick-view"]')
  const tags = parent?.querySelectorAll('[data-animate="block-tag"]')

  isHover.value = false

  /*if (hasPreview.value) {
    gsap.to(video, { autoAlpha: 0, duration, ease })
  }

  if (hasQuickView.value || props.alternative) {
    gsap.to(button, { y: '100%', duration: durationFast, ease, stagger: 0.1 })
  }
  if (tags?.length) {
    gsap.to(tags, { y: '100%', duration: durationFast, ease, stagger: 0.1 })
  }*/
}
</script>

<style lang="scss">
@import './style.scss';
</style>
